var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 237,
    viewBox: "0 0 291 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.63 96.7736C269.468 118.153 291.318 146.93 290.092 173.772C288.751 200.799 264.701 226.122 236.681 230.038C208.775 233.771 177.152 216.51 147.943 216.613C119.032 216.648 92.4192 234.229 63.1632 234.814C33.8384 235.101 1.98548 218.207 1.50792 194.899C0.915583 171.774 31.8824 142.349 42.3702 109.294C52.6745 76.1242 42.4997 39.3246 53.8442 19.5894C65.3035 -0.329209 98.2825 -3.18303 125.302 4.28927C152.321 11.7616 173.196 29.4455 192.581 45.4281C211.966 61.4109 229.792 75.3938 249.63 96.7736V96.7736Z",
    fill: "#3361F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.438 110.825C237.438 110.825 132.528 -5.09814 89.5495 22.281C46.571 49.6602 75.7424 103.739 94.1476 107.104C141.204 115.707 172.484 78.2312 193.205 116.602C213.926 154.973 230 154.293 268.369 146.597C306.738 138.901 247.072 128.874 237.438 110.825V110.825Z",
    fill: "#4F75F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6 144.066C23.34 144.688 -11.4304 189.712 5.50299 209.804C14.752 220.778 38.2267 239.298 73.4453 235.872C89.6514 235.851 147.776 204.019 191.28 226.523C191.28 226.523 218.296 234.961 243.28 231.036C263.341 227.885 274.145 213.81 283.16 196.811C241.479 241.192 173.766 209.276 150.823 181.997C122.514 148.338 16.8225 216.378 24.6 144.066V144.066Z",
    fill: "#2D42C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBlob);
export default __webpack_public_path__ + "static/media/blue-blob.e63aeb8ae7f13d4714b92c3cb7f7914b.svg";
export { ForwardRef as ReactComponent };